import { BaseState } from '@/store/base-state';
import { Reports } from '@/modules/reports/types';
import { TableOptions } from '@/types';
import { ReportOrderTypes } from '@/enums';

export default class ReportsState extends BaseState {
  reports: Reports.Report[] = [];
  permissions: Reports.Permission[] =[];
  loading = false;

  report_order_filters: Reports.ReportOrderFilters = {
    organizations: [],
    delivery_types: [],
    warehouses: [],
    delivery_addresses: [],
    cancel_reasons: [],
    contracts: [],
    order_numbers: [],
  };

  total_exist = false;
  total: Reports.OrdersReportsTotalInfo = {
    dates: null,
    orders: null,
    products_quantity: null,
    price: null,
    volume: null,
    weight: null,
  };

  filters_exist = false;
  filters: Reports.OrdersReportsFilters = {
    date: [],
    organization_ids: null,
    delivery_types: null,
    delivery_address_ids: null,
    contracts: null,
    warehouses_ids: null,
    cancel_reasons_ids: null,
    order_numbers: null,
    type: ReportOrderTypes.SHIPPED,
  };

  filters_changed = false;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['shipment_at'],
    sortDesc: [true],
  };

  show_tables = false;

  tab_maps: Reports.TabsMapState = {
    0: { type: ReportOrderTypes.SHIPPED, sortBy: ['shipment_at'] },
    1: { type: ReportOrderTypes.NOT_SHIPPED, sortBy: ['reserve_quantity'] },
    2: { type: ReportOrderTypes.CANCELED, sortBy: ['canceled_at'] },
    3: { type: ReportOrderTypes.READY_SHIPPED, sortBy: [''] },
  };
}
